import { DEFAULT_LOCATIONS, SANDBOX, PASSWORD } from 'utils/constants';
import { selectToken } from 'utils/selectToken';
import acmeHeaderLogo from 'assets/pg-acme-header-logo.svg';
import acmeLoginLogo from 'assets/pg-acme-login-logo.png';

export const apiTokens = {
  dev: 'Token 97d88ef2829197e7cb309c4f1fe7ee1f4e7081a1',
  staging: 'Token 97ef9f03bdeee1dc3eb93ebe30289527cdd1f647',
  prod: 'Token eb8f919f43625faff31e3541a4374268a0196727',
};

const token = selectToken(apiTokens);

const sandboxConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'sandbox',

  API_TOKEN: token,
  EMBOLD_CLIENT: SANDBOX,

  // login
  LOGIN_NETWORK_NAME: 'sandboxUserId',
  SHOW_REGION_SELECTOR: true,
  PASSWORD_REGEX: ['sandbox', 'i'],

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Nashville },

  // content
  DISPLAY_NAME: 'SANDBOX',
  HEADER_LOGO: acmeHeaderLogo,
  FORM_VARIANT: PASSWORD,
  EMBOLD_LOGO_PRESENT: true,
  LOCAL_LOGO_ASSET: acmeLoginLogo,
  NO_WELCOME_LINK: false,
  DEFAULT_SEARCH_RADIUS: 10,
};

export default sandboxConfig;
